import { render, staticRenderFns } from "./modalAnadirSeleccion.vue?vue&type=template&id=19cb0fbd"
import script from "./modalAnadirSeleccion.vue?vue&type=script&lang=js"
export * from "./modalAnadirSeleccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports